import Top from "./top/main.es6";

const top = new Top();
